<template>
  <section class="Map-overlay-container">
    <ux-molecules-map-restaurant-slider :cards="cards" :label="label" v-if="!isDesktop" />
    <ux-molecules-map-restaurant-list :cards="cards" :label="label" v-if="isDesktop" />
  </section>
</template>
<script lang="ts" setup>
import type { cardType } from '~/components/ux/molecules/CardRestaurant/types';

export interface MapOverlayContainerProps {
  cards: cardType[][] | null;
  label?: null | string;
}

defineProps<MapOverlayContainerProps>();

const { isDesktop } = useCurrentWindowSize();
</script>
<style lang="scss" scoped>
@use 'MapOverlayContainer.scss';
</style>
